import { useState } from "react";
import { Link } from "react-router-dom";
import { apiFetch } from "../utils/apiFetch";

export default function SuggestProperty() {
  const [form, setForm] = useState({ name: "", location: "", type: "Residential", reason: "", contactOk: true });
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!form.name || !form.location) return;
    setLoading(true);
    try {
      await apiFetch("/api/community-properties/suggest", {
        method: "POST",
        headers: { Authorization: "Bearer " + localStorage.getItem("token") },
        body: form,
      });
      setSubmitted(true);
    } catch (e) {
      console.error("[suggest-property] submit failed:", e);
    }
    setLoading(false);
  };

  if (submitted) return (
    <div style={{ minHeight: "100vh", background: "#FAFAF8", display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}>
      <div style={{ textAlign: "center", maxWidth: 400 }}>
        <div style={{ fontSize: 48, marginBottom: 16 }}>🏢</div>
        <h2 style={{ fontSize: 22, fontWeight: 800, marginBottom: 8 }}>Thank you!</h2>
        <p style={{ color: "#666", marginBottom: 24 }}>We've received your property suggestion. Our team will review it and get back to you if it looks promising.</p>
        <Link to="/properties" style={{ display: "inline-block", padding: "12px 28px", background: "#c84b0f", color: "#fff", borderRadius: 10, textDecoration: "none", fontWeight: 700 }}>Back to Properties</Link>
      </div>
    </div>
  );

  return (
    <div style={{ minHeight: "100vh", background: "#FAFAF8", padding: "40px 20px" }}>
      <div style={{ maxWidth: 520, margin: "0 auto" }}>
        <Link to="/properties" style={{ color: "#888", fontSize: 13, textDecoration: "none", display: "block", marginBottom: 24 }}>← Back to Properties</Link>
        <h1 style={{ fontSize: 24, fontWeight: 800, marginBottom: 6 }}>Suggest a Property</h1>
        <p style={{ color: "#666", fontSize: 14, marginBottom: 28, lineHeight: 1.6 }}>
          Know a property that would make a great investment? Tell us about it. Our team reviews every suggestion — if it looks strong, we'll shortlist it as a community property.
        </p>

        <div style={{ background: "#fff", borderRadius: 16, padding: 24, border: "1px solid #EDE8E3" }}>
          <div style={{ marginBottom: 16 }}>
            <label style={{ display: "block", fontSize: 13, fontWeight: 600, color: "#333", marginBottom: 6 }}>Property Name / Project *</label>
            <input value={form.name} onChange={e => setForm({...form, name: e.target.value})} placeholder="e.g. Godrej BKC Tower" style={{ width: "100%", padding: "10px 14px", borderRadius: 8, border: "1px solid #ddd", fontSize: 14, boxSizing: "border-box" }} />
          </div>
          <div style={{ marginBottom: 16 }}>
            <label style={{ display: "block", fontSize: 13, fontWeight: 600, color: "#333", marginBottom: 6 }}>Location *</label>
            <input value={form.location} onChange={e => setForm({...form, location: e.target.value})} placeholder="e.g. BKC, Mumbai" style={{ width: "100%", padding: "10px 14px", borderRadius: 8, border: "1px solid #ddd", fontSize: 14, boxSizing: "border-box" }} />
          </div>
          <div style={{ marginBottom: 16 }}>
            <label style={{ display: "block", fontSize: 13, fontWeight: 600, color: "#333", marginBottom: 6 }}>Property Type</label>
            <select value={form.type} onChange={e => setForm({...form, type: e.target.value})} style={{ width: "100%", padding: "10px 14px", borderRadius: 8, border: "1px solid #ddd", fontSize: 14, background: "#fff", boxSizing: "border-box" }}>
              <option>Residential</option>
              <option>Commercial</option>
              <option>Co-living / Managed</option>
              <option>Retail</option>
              <option>Warehouse / Industrial</option>
            </select>
          </div>
          <div style={{ marginBottom: 20 }}>
            <label style={{ display: "block", fontSize: 13, fontWeight: 600, color: "#333", marginBottom: 6 }}>Why is this a good investment? (optional)</label>
            <textarea value={form.reason} onChange={e => setForm({...form, reason: e.target.value})} placeholder="Location, developer reputation, rental demand, price..." rows={3} style={{ width: "100%", padding: "10px 14px", borderRadius: 8, border: "1px solid #ddd", fontSize: 14, resize: "vertical", boxSizing: "border-box" }} />
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 20 }}>
            <input type="checkbox" id="contactOk" checked={form.contactOk} onChange={e => setForm({...form, contactOk: e.target.checked})} />
            <label htmlFor="contactOk" style={{ fontSize: 13, color: "#555" }}>EstateCoin can contact me about this suggestion</label>
          </div>
          <button onClick={handleSubmit} disabled={loading || !form.name || !form.location} style={{ width: "100%", padding: "14px", background: loading ? "#ccc" : "linear-gradient(135deg,#c84b0f,#e55a1f)", color: "#fff", border: "none", borderRadius: 10, fontWeight: 700, fontSize: 15, cursor: "pointer" }}>
            {loading ? "Submitting..." : "Submit Suggestion →"}
          </button>
        </div>

        <p style={{ fontSize: 11, color: "#aaa", textAlign: "center", marginTop: 16, lineHeight: 1.6 }}>
          Suggesting a property does not guarantee it will be acquired. All properties go through legal and financial due diligence before being listed. White Soil Advisors LLP · LLPIN AAT-7542
        </p>
      </div>
    </div>
  );
}
